// extracted by mini-css-extract-plugin
module.exports = {"container":"Alert_container__xtE19","icon":"Alert_icon__0aBqb","content":"Alert_content__O_iS1"};